import {OktaAuth, toRelativeUrl} from '@okta/okta-auth-js';
import {Security} from '@okta/okta-react';
import {useNavigate} from 'react-router-dom';
import {OktaProviderProps} from './interface';

const oktaAuth = new OktaAuth({
  issuer: `${process.env.REACT_APP_OKTA_DOMAIN}`,
  clientId: `${process.env.REACT_APP_OKTA_CLIENT_ID}`,
  redirectUri: `${process.env.REACT_APP_OKTA_REDIRECT_URI}`,
  postLogoutRedirectUri: `${process.env.REACT_APP_OKTA_POST_LOGOUT_REDIRECT_URI}`,
  scopes: ['openid', 'profile', 'email', 'offline_access'],
  pkce: true,
});

const OktaProvider = ({children}: OktaProviderProps) => {
  const navigate = useNavigate();
  const restoreOriginalUri = (_oktaAuth: OktaAuth, originalUri: string) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin), {
      replace: true,
    });
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  );
};

export default OktaProvider;
